// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropdown-group__separator {
  display: none;
}
.dropdown-group + .dropdown-group .dropdown-group__separator {
  display: block;
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/libs/shared/venus/ui/components/dropdown-menu/DropdownGroup.less"],"names":[],"mappings":"AACE;EACE,aAAA;AAAJ;AAEE;EAEI,cAAA;AADN","sourcesContent":[".dropdown-group {\n  &__separator {\n    display: none;\n  }\n  & + & {\n    .dropdown-group__separator {\n      display: block;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
